import React from 'react';

import { noop } from 'lodash';
import { ReactTyped } from 'react-typed';

export interface TypingEffectProps {
  strings: string[];
  typeSpeed?: number;
  backSpeed?: number;
  loop?: boolean;
  startDelay?: number;
  backDelay?: number;
  showCursor?: boolean;
  cursorChar?: string;
  className?: string;
  onBegin?: () => void;
  onComplete?: () => void;
}

const TypingEffect: React.FC<TypingEffectProps> = ({
  strings,
  typeSpeed = 10,
  backSpeed = 10,
  loop = false,
  startDelay = 0,
  backDelay = 0,
  showCursor = false,
  cursorChar = '',
  className = '',
  onBegin = noop,
  onComplete = noop,
}) => {
  return (
    <span className={className}>
      <ReactTyped
        strings={strings}
        typeSpeed={typeSpeed}
        backSpeed={backSpeed}
        loop={loop}
        startDelay={startDelay}
        backDelay={backDelay}
        showCursor={showCursor}
        cursorChar={cursorChar}
        onComplete={onComplete}
        onBegin={onBegin}
        smartBackspace={false}
      />
    </span>
  );
};

export default TypingEffect;
